import { Button } from "@mui/material";
import { Card } from "@mui/material";
import { CardActions } from "@mui/material";
import { CardContent } from "@mui/material";
import { CardHeader } from "@mui/material";
import { CardMedia } from "@mui/material";
import FavoriteIcon from '@mui/icons-material/Favorite';
import { IconButton } from "@mui/material";
import PropTypes from 'prop-types';
import React from 'react';
import ShareIcon from '@mui/icons-material/Share';
import { Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  media: {
    height: 0
  },
  actions: {
    display: 'flex'
  },
  clamp: {
    position: 'relative',
    height: '4.5em',
    overflow: 'hidden',
    '&:after': {
      content: '""',
      textAlign: 'right',
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '40%',
      height: '1.5em',
      background: `linear-gradient(to right, #ffffff 0, #ffffff 50%)`
    }
  }
}));

const PostCard = ({ title, subtitle, text, image, imageHeight, avatar }) => {
  const classes = useStyles();
  return (
    <Card>
      <CardHeader avatar={avatar} title={title} subheader={subtitle} />
      <CardMedia
        image={image}
        title={title}
        className={classes.media}
        style={{ paddingTop: imageHeight }}
      />
      <CardContent>
        <Typography component="p" className={classes.clamp}>
          {text}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions} disableSpacing>
        <IconButton aria-label="Add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="Share">
          <ShareIcon />
        </IconButton>
        <span className="flexSpacer" />
        <Button>More Info</Button>
        <Button>Download</Button>
      </CardActions>
    </Card>
  );
};

PostCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageHeight: PropTypes.number,
  avatar: PropTypes.element
};

export default PostCard;
